import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 20%;
  .group{
    position:relative;
  }
  .group>label{
    color: ${(props) => props.theme.colors.colorPageInputLabel};
    padding: 0 12px 0 2px ;
    position: absolute;
    top: -0.5em;
    left: 1em;
    background-color: ${(props) => props.theme.colors.backgroundColorPageInput};
    font-size: 14px;
    font-family: "Roboto","Helvetica neue","Lato",sans-serif;
    @media (max-width: 586px) {
      font-size: 10px;
      padding: 0;
    }
  }
  
  .group>input{    
    width: 100%;
    color: ${(props) => props.theme.colors.text.placeholder};
    background-color: ${(props) => props.theme.colors.backgroundColorPageInput};
    padding: 10px 35px 10px 16px;
    border-radius: 10px;
    border: 0;  
    outline:none;
    border: 1px solid ${(props) => props.theme.colors.nextPageInputBorder};
    font-family: "Roboto","Helvetica neue","Lato",sans-serif;
  }
  .group>input:focus {        
    box-shadow: 0 0 2px ${(props) => props.theme.colors.nextPageInputBorder};
}
  button{
    position: absolute;
    left: 121px;    
  }
`;
